import {
  useCallback,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { SidebarCollapseContext } from "@/shared/ui/layout/sidebarCollapseContext";

type SidebarCollapseProviderProps = {
  children: ReactNode;
};

export function SidebarCollapseProvider({ children }: SidebarCollapseProviderProps) {
  const [forceCollapsed, setForceCollapsedState] = useState(false);

  const setForceCollapsed = useCallback((collapsed: boolean) => {
    setForceCollapsedState(collapsed);
  }, []);

  const value = useMemo(
    () => ({
      forceCollapsed,
      setForceCollapsed,
    }),
    [forceCollapsed, setForceCollapsed],
  );

  return (
    <SidebarCollapseContext.Provider value={value}>
      {children}
    </SidebarCollapseContext.Provider>
  );
}
